import React from "react";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Box, Button, Tab, Tabs } from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import OfferTable from "./dinning/offerTable";

import CustomPagination from "../../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import FilterMenu from "../../components/filterMenu";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function OfferManagement() {
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getOfferType = () => {
    switch (valueTabs) {
      case 0:
        return "dining";
      case 1:
        return "event";
      case 2:
        return "experience";
      case 3:
        return "beach-club";
      case 4:
        return "benefit";
      case 5:
        return "wellness";
      default:
        return "dining";
    }
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const navigate = useNavigate();
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Offer Management</h1>
          </div>
          <div className="right_s">
            <SearchBar searchTerm={""} placeholder={"Search offer"} />
            <Button className="btn btn_primary">
              <img src="/static/images/export_icon.svg" alt="icon" /> Export
              Data
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() =>
                navigate("/manage-offer/build-offer", {
                  state: {
                    type:
                      valueTabs === 1
                        ? "EVENT"
                        : valueTabs === 2
                        ? "EXPERIENCE"
                        : valueTabs === 6
                        ? "OTHERS"
                        : "RESTAURANT", // fallback
                  },
                })
              }
            >
              <ControlPointIcon /> Build Offer
            </Button>
            <FilterMenu />
          </div>
        </div>

        <Box
          className="custom_tabs2 offer_manage_tab mt_40 mb_30"
          sx={{ width: "100%" }}
        >
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Dining" {...a11yProps(0)} />
            <Tab label="Events" {...a11yProps(1)} />
            <Tab label="Experience" {...a11yProps(2)} />
            <Tab label="Beach Clubs" {...a11yProps(3)} />
            <Tab label="Benefits" {...a11yProps(4)} />
            <Tab label="Wellness" {...a11yProps(5)} />
            <Tab label="Others" {...a11yProps(6)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards table_cards v2">
            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Active" {...a11yProps(0)} />
                <Tab label="Scheduled" {...a11yProps(1)} />
                <Tab label="Expired" {...a11yProps(2)} />
                <Tab label="Archived " {...a11yProps(3)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <OfferTable actionType="active" offerType="dining" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <OfferTable actionType="scheduled" offerType="dining" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
              <OfferTable actionType="expired" offerType="dining" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
              <OfferTable actionType="archived" offerType="dining" />
            </CustomTabPanel>
          </div>
          <CustomPagination />
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards table_cards v2">
            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Active" {...a11yProps(0)} />
                <Tab label="Scheduled" {...a11yProps(1)} />
                <Tab label="Expired" {...a11yProps(2)} />
                <Tab label="Archived " {...a11yProps(3)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <OfferTable actionType="active" offerType="event" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <OfferTable actionType="scheduled" offerType="event" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
              <OfferTable actionType="expired" offerType="event" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
              <OfferTable actionType="archived" offerType="event" />
            </CustomTabPanel>
          </div>
          <CustomPagination />
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={2}>
          <div className="cards table_cards v2">
            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Active" {...a11yProps(0)} />
                <Tab label="Scheduled" {...a11yProps(1)} />
                <Tab label="Expired" {...a11yProps(2)} />
                <Tab label="Archived " {...a11yProps(3)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <OfferTable actionType="active" offerType="experience"/>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <OfferTable actionType="scheduled" offerType="experience"/>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
              <OfferTable actionType="expired" offerType="experience"/>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
              <OfferTable actionType="archived" offerType="experience"/>
            </CustomTabPanel>
          </div>
          <CustomPagination />
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={3}>
          <div className="cards table_cards v2">
            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Active" {...a11yProps(0)} />
                <Tab label="Scheduled" {...a11yProps(1)} />
                <Tab label="Expired" {...a11yProps(2)} />
                <Tab label="Archived " {...a11yProps(3)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <OfferTable actionType="active" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <OfferTable actionType="scheduled" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
              <OfferTable actionType="expired" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
              <OfferTable actionType="archived" />
            </CustomTabPanel>
          </div>
          <CustomPagination />
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={4}>
          <div className="cards table_cards v2">
            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Active" {...a11yProps(0)} />
                <Tab label="Scheduled" {...a11yProps(1)} />
                <Tab label="Expired" {...a11yProps(2)} />
                <Tab label="Archived " {...a11yProps(3)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <OfferTable actionType="active" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <OfferTable actionType="scheduled" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
              <OfferTable actionType="expired" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
              <OfferTable actionType="archived" />
            </CustomTabPanel>
          </div>
          <CustomPagination />
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={5}>
          <div className="cards table_cards v2">
            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Active" {...a11yProps(0)} />
                <Tab label="Scheduled" {...a11yProps(1)} />
                <Tab label="Expired" {...a11yProps(2)} />
                <Tab label="Archived " {...a11yProps(3)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <OfferTable actionType="active" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <OfferTable actionType="scheduled" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
              <OfferTable actionType="expired" />
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
              <OfferTable actionType="archived" />
            </CustomTabPanel>
          </div>
          <CustomPagination />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={6}>
          <div className="cards table_cards v2">
            <Box className="custom_tabs" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Active" {...a11yProps(0)} />
                <Tab label="Scheduled" {...a11yProps(1)} />
                <Tab label="Expired" {...a11yProps(2)} />
                <Tab label="Archived " {...a11yProps(3)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <OfferTable actionType="active" offerType="others"/>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <OfferTable actionType="scheduled" offerType="others"/>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={2}>
              <OfferTable actionType="expired" offerType="others"/>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={3}>
              <OfferTable actionType="archived" offerType="others"/>
            </CustomTabPanel>
          </div>
          <CustomPagination />
        </CustomTabPanel>
      </MainContainer>
    </>
  );
}

export default OfferManagement;
